import { ITooltipComp, ITooltipParams } from '@ag-grid-community/core';

import { getGuiBasedOnRowIndexAndColId, isOverflowing } from './ag-raw-tooltip.utils';

export interface AgRawTooltipParams {
  // return custom element for custom cells,
  // or return null to hide tooltip
  getNode?: (props: {
    params: ITooltipParams;
    targetNode: Element | null;
  }) => HTMLElement | null | undefined;
}

// Type for custom tooltip value with forceTooltip support
export type AgRawTooltipValue = { forceTooltip?: boolean; value: string };

export class AgRawTooltip implements ITooltipComp {
  eGui!: HTMLDivElement;

  getGui() {
    return this.eGui;
  }

  getNode(params: ITooltipParams) {
    if (params.node && params.column && params.node.rowIndex != null) {
      return getGuiBasedOnRowIndexAndColId(params.node.rowIndex, params.column.getUniqueId() || '');
    }

    return null;
  }

  init(params: AgRawTooltipParams & ITooltipParams) {
    const eGui = (this.eGui = document.createElement('div'));
    let targetNode = this.getNode(params);

    let tooltipValue: string = params.valueFormatted || params.value || '';
    let forceTooltip = false;

    if (typeof params.value === 'object' && params.value !== null) {
      const obj = params.value as AgRawTooltipValue;

      forceTooltip = !!obj.forceTooltip;
      tooltipValue = obj.value;
    }

    if (params.location === 'cell' && params.getNode) {
      targetNode =
        params.getNode({
          params,
          targetNode,
        }) || null;

      if (!targetNode) {
        return;
      }
    }

    let shouldShowTooltip = true;

    if (targetNode && !forceTooltip) {
      const tolerance = 2;
      const hasValidationError = !!Object.keys(params.data?.errors || {}).length;

      if (
        !((<HTMLElement>targetNode).offsetWidth + tolerance <= targetNode.scrollWidth) &&
        !hasValidationError
      ) {
        if (params.hideTooltipCallback) {
          params.hideTooltipCallback();
        }

        if (!isOverflowing(targetNode)) {
          shouldShowTooltip = false;
        }

        return;
      }
    }

    if (!shouldShowTooltip) {
      if (params.hideTooltipCallback) {
        params.hideTooltipCallback();
      }

      return;
    }

    eGui.classList.add('ag-tooltip');
    eGui.innerHTML = tooltipValue || '';
  }
}
